import PublicPage from '@/shared/PublicPage/PublicPage';

export default function TermsOfUse() {
  return (
    <PublicPage withFooter>
      <h1>PRIVACY POLICY</h1>
      <p>
        ROCKALINGUA INC ("us", "we", or "our") operates the{' '}
        <a href="http://www.rockalingua.com">www.rockalingua.com</a> website
        (the "Service").
      </p>
      <p>
        Rockalingua Inc is committed to keeping all users’ personal information
        safe and private.
      </p>
      <p>
        This page informs you of our policies regarding the collection, use, and
        disclosure of personal data when you use our Service and the choices you
        have associated with that data.
      </p>
      <p>
        We use your data to provide and improve the Service. By using the
        Service, you agree to the collection and use of information in
        accordance with this policy. Unless otherwise defined in this Privacy
        Policy, terms used in this Privacy Policy have the same meanings as in
        our Terms and Conditions, accessible from{' '}
        <a href="http://www.rockalingua.com">www.rockalingua.com</a>
      </p>
      <h2>Definitions</h2>
      <p>
        <strong>Service</strong>
      </p>
      <p>
        Service is the{' '}
        <a href="http://www.rockalingua.com">www.rockalingua.com</a> website
        operated by ROCKALINGUA INC
      </p>
      <p>
        <strong>Personal Data</strong>
      </p>
      <p>
        Personal Data means data about a living individual who can be identified
        from those data (or from those and other information either in our
        possession or likely to come into our possession).
      </p>
      <p>
        <strong>Usage Data</strong>
      </p>
      <p>
        Usage Data is data collected automatically either generated by the use
        of the Service or from the Service infrastructure itself (for example,
        the duration of a page visit).
      </p>
      <p>
        <strong>Cookies</strong>
      </p>
      <p>
        Cookies are small pieces of data stored on your device (computer or
        mobile devices). Please refer to the "cookies" section below for detail
        information about cookies and how we iuse them.
      </p>
      <p>
        <strong>Data Controller</strong>
      </p>
      <p>
        Data Controller means the natural or legal person who (either alone or
        jointly or in common with other persons) determines the purposes for
        which and the manner in which any personal information are, or are to
        be, processed.
      </p>
      <p>
        For the purpose of this Privacy Policy, we are a Data Controller of your
        Personal Data.
      </p>
      <p>
        <strong>Data Processors (or Service Providers)</strong>
      </p>
      <p>
        Data Processor (or Service Provider) means any natural or legal person
        who processes the data on behalf of the Data Controller.
      </p>
      <p>
        We may use the services of various Service Providers in order to process
        your data more effectively.
      </p>
      <p>
        <strong>Data Subject (or User)</strong>
      </p>
      <p>
        Data Subject is any living individual who is using our Service and is
        the subject of Personal Data.
      </p>
      <h2>Information Collection and Use</h2>
      <p>
        We collect several different types of information for various purposes
        to provide and improve our Service to you.
      </p>
      <h3>Types of Data Collected</h3>
      <h4>Personal Data</h4>
      <p>
        <strong>
          Students will never have to provide email addresses, physical
          addresses, school names or phone numbers.
        </strong>
        &nbsp;Only teachers or families (that subscribe to our family
        membership) have to provide us with certain personally identifiable
        information that can be used to activate the membership and to
        contact&nbsp; you ("Personal Data"). Personally identifiable information
        that we need is:
      </p>
      <ul>
        <li>Email address</li>
        <li>
          First name and last name (or initials if they do not want to enter
          full name and/or last name)
        </li>
        <li>
          We may use your Personal Data to contact you with newsletters (to let
          you know about new teaching resources uploaded to our
          website)&nbsp;&nbsp;
          <u>
            <strong>
              You may opt out of receiving any, or all, of these communications
              from us by following the unsubscribe link or instructions provided
              in any email we send.
            </strong>
          </u>
        </li>
      </ul>
      <h4>Children’s privacy</h4>
      <p>
        <strong>Rockalingua is FERPA and COPPA compliant.</strong>
      </p>
      <p>
        The Children’s Online Privacy Protection Act of 1998 (COPPA) and other
        laws have been established to protect the privacy of minors. At
        Rockalingua Inc we take the privacy rights of our users, especially
        children, very seriously, and abide&nbsp;by all federal and state laws
        and guidelines regarding youth privacy. The following outlines our
        general children’s privacy guidelines:
      </p>
      <p>
        Rockalingua Inc. exists to serve educators, parents and students and
        strives to provide a safe, positive experience for children. To ensure
        this, we adhere to the following policies:
      </p>
      <ul>
        <li>
          We do not distribute any personally identifiable information about
          children to third parties.
        </li>
        <li>
          We do not allow students to publicly post or distribute personally
          identifiable contact information without prior parental consent.&nbsp;
        </li>
        <li>
          Rockalingua Inc. provides an online service marketed towards
          educators. The services we provide to students/minors are solely for
          the use and benefit of their school, and for no other commercial
          purpose. To that end, COPPA allows the school of the student/minor to
          act as the parent’s agent, and can consent to the collection of kid’s
          information on the parent’s behalf.
        </li>
      </ul>
      <h4>Usage Data</h4>
      <p>
        We may also collect&nbsp;the pages of our Service that you visit, the
        time and date of your visit and&nbsp;the time spent on those pages.
      </p>
      <h4>Tracking Cookies Data</h4>
      <p>
        We use cookies and similar tracking technologies to track the activity
        on our Service and hold certain information.
      </p>
      <p>
        Cookies are files with small amount of data which may include an
        anonymous unique identifier. Cookies are sent to your browser from a
        website and stored on your device. Tracking technologies also used are
        beacons, tags, and scripts to collect and track information and to
        improve and analyze our Service.
      </p>
      <p>
        <u>
          <strong>
            You can instruct your browser to refuse all cookies or to indicate
            when a cookie is being sent.&nbsp;
          </strong>
        </u>
      </p>
      <p>Examples of Cookies we use:</p>
      <ul>
        <li>
          <strong>Session Cookies.</strong> We use Session Cookies to operate
          our Service.
        </li>
        <li>
          <strong>Preference Cookies.</strong> We use Preference Cookies to
          remember your preferences and various settings.
        </li>
        <li>
          <strong>Security Cookies.</strong> We use Security Cookies for
          security purposes.
        </li>
      </ul>
      <h2>Use of Data</h2>
      <p>ROCKALINGUA INC uses the collected data for various purposes:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service</li>
        <li>
          To allow you to participate in interactive features of our Service
          when you choose to do so
        </li>
        <li>To provide customer support</li>
        <li>
          To gather analysis or valuable information so that we can improve our
          Service
        </li>
        <li>To monitor the usage of our Service</li>
        <li>To detect, prevent and address technical issues</li>
        <li>
          To provide you with news about our&nbsp;services. You can&nbsp;opt to
          not receive this information.
        </li>
      </ul>
      <h2>
        Legal Basis for Processing Personal Data Under General Data Protection
        Regulation (GDPR)
      </h2>
      <p>
        If you are from the European Economic Area (EEA), ROCKALINGUA INC legal
        basis for collecting and using the personal information described in
        this Privacy Policy depends on the Personal Data we collect and the
        specific context in which we collect it.
      </p>
      <p>ROCKALINGUA INC may process your Personal Data because:</p>
      <ul>
        <li>We need to perform a contract with you</li>
        <li>You have given us permission to do so</li>
        <li>
          The processing is in our legitimate interests and it's not overridden
          by your rights
        </li>
        <li>For payment processing purposes</li>
        <li>To comply with the law</li>
      </ul>
      <h2>Retention of Data</h2>
      <p>
        Subscribers can request to review and delete the data related to their
        accounts at any time by emailing{' '}
        <a href="mailto:support@rockalingua.com">support@rockalingua.com</a>
      </p>
      <p>
        ROCKALINGUA INC will retain your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will
        retain and use your Personal Data to the extent necessary to comply with
        our legal obligations (for example, if we are required to retain your
        data to comply with applicable laws), resolve disputes, and enforce our
        legal agreements and policies.
      </p>
      <p>
        ROCKALINGUA INC will also retain Usage Data for internal analysis
        purposes. Usage Data is generally retained for a shorter period of time,
        except when this data is used to strengthen the security or to improve
        the functionality of our Service, or we are legally obligated to retain
        this data for longer time periods.
      </p>
      <h2>Transfer of Data</h2>
      <p>
        Your information, including Personal Data, may be transferred to — and
        maintained on — computers located outside of your state, province,
        country or other governmental jurisdiction where the data protection
        laws may differ than those from your jurisdiction.
      </p>
      <p>
        If you are located outside United States and choose to provide
        information to us, please note that we transfer the data, including
        Personal Data, to United States and process it there.
      </p>
      <p>
        Your consent to this Privacy Policy followed by your submission of such
        information represents your agreement to that transfer.
      </p>
      <p>
        ROCKALINGUA INC will take all steps reasonably necessary to ensure that
        your data is treated securely and in accordance with this Privacy Policy
        and no transfer of your Personal Data will take place to an organization
        or a country unless there are adequate controls in place including the
        security of your data and other personal information.
      </p>
      <h2>Disclosure of Data</h2>
      <h3>Disclosure for Law Enforcement</h3>
      <p>
        Under certain circumstances, ROCKALINGUA INC may be required to disclose
        your Personal Data if required to do so by law or in response to valid
        requests by public authorities (e.g. a court or a government agency).
      </p>
      <h3>Legal Requirements</h3>
      <p>
        ROCKALINGUA INC may disclose your Personal Data in the good faith belief
        that such action is necessary to:
      </p>
      <ul>
        <li>To comply with a legal obligation</li>
        <li>To protect and defend the rights or property of ROCKALINGUA INC</li>
        <li>
          To prevent or investigate possible wrongdoing in connection with the
          Service
        </li>
        <li>
          To protect the personal safety of users of the Service or the public
        </li>
        <li>To protect against legal liability</li>
      </ul>
      <h2>Security of Data</h2>
      <p>
        The security of your data is important to us.&nbsp;We implement a
        variety of security measures to maintain the safety of your personal
        information. Your personal information is contained behind secured
        networks and is only accessible by a limited number of persons who have
        special access rights to such systems, and are required to keep the
        information confidential. When you place orders or access your personal
        information, we offer the use of a secure server. All information you
        supply is transmitted via Secure Socket Layer (SSL) technology.
      </p>
      <p>
        but remember that no method of transmission over the Internet, or method
        of electronic storage is 100% secure. While we strive to use
        commercially acceptable means to protect your Personal Data, we cannot
        guarantee its absolute security.
      </p>
      <p>&nbsp;</p>
      <h2>Data breach plan</h2>
      <p>
        Rockalingua has implemented administrative and technical safeguards it
        believes are appropriate to protect the confidentiality, integrity and
        availability of your personal data and access credentials. However,
        given sufficient resources, a determined attacker could defeat those
        safeguards and may, as a result, gain access to the data we seek to
        protect. In the event a malicious attack is successful and user data is
        affected, we will immediately notify all affected customers.
      </p>
      <h2>
        "Do Not Track" Signals Under California Online Privacy Protection Act
        (CalOPPA)
      </h2>
      <p>
        We do not support Do Not Track ("DNT"). Do Not Track is a preference you
        can set in your web browser to inform websites that you do not want to
        be tracked.
      </p>
      <p>
        You can enable or disable Do Not Track by visiting the Preferences or
        Settings page of your web browser.
      </p>
      <h2>
        Your Data Protection Rights Under General Data Protection Regulation
        (GDPR)
      </h2>
      <p>
        If you are a resident of the European Economic Area (EEA), you have
        certain data protection rights. ROCKALINGUA INC aims to take reasonable
        steps to allow you to correct, amend, delete, or limit the use of your
        Personal Data.
      </p>
      <p>
        If you wish to be informed what Personal Data we hold about you and if
        you want it to be removed from our systems, please contact us.
      </p>
      <p>
        In certain circumstances, you have the following data protection rights:
      </p>
      <p>
        <strong>
          The right to access, update or to delete the information we have on
          you.
        </strong>{' '}
        Whenever made possible, you can access, update or request deletion of
        your Personal Data directly within your account settings section. If you
        are unable to perform these actions yourself, please contact us to
        assist you.
      </p>
      <p>
        <strong>The right of rectification.</strong> You have the right to have
        your information rectified if that information is inaccurate or
        incomplete.
      </p>
      <p>
        <strong>The right to object.</strong> You have the right to object to
        our processing of your Personal Data.
      </p>
      <p>
        <strong>The right of restriction.</strong> You have the right to request
        that we restrict the processing of your personal information.
      </p>
      <p>
        <strong>The right to data portability.</strong> You have the right to be
        provided with a copy of the information we have on you in a structured,
        machine-readable and commonly used format.
      </p>
      <p>
        <strong>The right to withdraw consent.</strong> You also have the right
        to withdraw your consent at any time where ROCKALINGUA INC relied on
        your consent to process your personal information.
      </p>
      <p>
        Please note that we may ask you to verify your identity before
        responding to such requests.
      </p>
      <p>
        You have the right to complain to a Data Protection Authority about our
        collection and use of your Personal Data. For more information, please
        contact your local data protection authority in the European Economic
        Area (EEA).
      </p>
      <h3>Payments</h3>
      <p>
        We may provide paid products and/or services within the Service. In that
        case, we use third-party services for payment processing (e.g. payment
        processors).
      </p>
      <p>
        We will not store or collect your payment card details. That information
        is provided directly to our third-party payment processors whose use of
        your personal information is governed by their Privacy Policy. These
        payment processors adhere to the standards set by PCI-DSS as managed by
        the PCI Security Standards Council, which is a joint effort of brands
        like Visa, Mastercard, American Express and Discover. PCI-DSS
        requirements help ensure the secure handling of payment information.
      </p>
      <p>The payment processors we work with are:</p>
      <p>
        <strong>PayPal or Braintree</strong>
      </p>
      <p>
        Their Privacy Policy can be viewed at{' '}
        <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full">
          https://www.paypal.com/webapps/mpp/ua/privacy-full
        </a>
      </p>
      <p>
        <strong>Authorize.net</strong>
      </p>
      <p>
        Their Privacy Policy can be viewed at{' '}
        <a href="https://www.authorize.net/company/privacy/">
          https://www.authorize.net/company/privacy/
        </a>
      </p>
      <h2>Links to Other Sites</h2>
      <p>
        Our Service may contain links to other sites that are not operated by
        us. If you click on a third party link, you will be directed to that
        third party's site. We strongly advise you to review the Privacy Policy
        of every site you visit.
      </p>
      <p>
        We have no control over and assume no responsibility for the content,
        privacy policies or practices of any third party sites or services.
      </p>
      <p>&nbsp;</p>
      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page.
      </p>
      <p>
        We will let you know via email and/or a prominent notice on our Service,
        prior to the change becoming effective and update the "effective date"
        at the top of this Privacy Policy.
      </p>
      <p>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us:
      </p>
      <ul>
        <li>
          By email:{' '}
          <a href="mailto:info@rockalingua.com">info@rockalingua.com</a>
        </li>
        <li>
          By visiting this page on our website:{' '}
          <a href="https://rockalingua.com/contact">
            https://rockalingua.com/contact
          </a>
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        Rockalingua works on all platforms (windows, chromebook, Apple IOS,
        Apple MacOS, Android)
      </p>
    </PublicPage>
  );
}
